import styled from 'styled-components';

export const CircularSVG = styled.svg`
  display: block;
`;
